export default {
      id: "color_bacteria_high-usage",
      viewBox: "0 0 267 365",
      url: __webpack_public_path__ + "sprite.svg#color_bacteria_high",
      toString: function () {
        return this.url;
      }
    }